export function findRedemptionLocationByAirportId(
  redemptionLocations: Array<App.ExperienceRedemptionLocation>,
  airportId?: string,
): App.ExperienceRedemptionLocation | undefined {
  if (!airportId) return undefined

  return redemptionLocations.find(location =>
    location.id === airportId || location.state === airportId,
  )
}
